var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container-sitc" },
    [
      _c("div", { staticClass: "filter-container-content" }, [
        _c(
          "div",
          { staticStyle: { padding: "0 40px" } },
          [
            _c("span", { staticClass: "title-h4" }, [
              _vm._v(_vm._s(_vm.$t("cargoTracking.title"))),
            ]),
            _vm._v(" "),
            _c(
              "el-form",
              {
                ref: "form",
                staticClass: "search-form",
                attrs: { model: _vm.form, rules: _vm.rules },
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 14 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 3 } },
                      [
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "el-select",
                              {
                                on: { change: _vm.changeQuery },
                                model: {
                                  value: _vm.selectValue,
                                  callback: function ($$v) {
                                    _vm.selectValue = $$v
                                  },
                                  expression: "selectValue",
                                },
                              },
                              _vm._l(_vm.selectOptions, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        this.selectValue === 0
                          ? _c(
                              "el-form-item",
                              { attrs: { prop: "blNo" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: _vm.$t("placeholder.blNo"),
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.form.blNo,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "blNo", $$v)
                                    },
                                    expression: "form.blNo",
                                  },
                                }),
                              ],
                              1
                            )
                          : _c(
                              "el-form-item",
                              { attrs: { prop: "containerNo" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "placeholder.containerNo"
                                    ),
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.form.containerNo,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "containerNo", $$v)
                                    },
                                    expression: "form.containerNo",
                                  },
                                }),
                              ],
                              1
                            ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "btn-primary",
                            attrs: { type: "primary" },
                            on: { click: _vm.toSearch },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("button.search")) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        !_vm.validateNull(_vm.baseInfo)
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "warning" },
                                on: { click: _vm.toSubscribe },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("voyagePlanSearch.subscribe")
                                    ) +
                                    "\n            "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.isResult
        ? _c(
            "div",
            { staticClass: "result-container" },
            [
              _c("div", [
                _c("tr", [
                  _c("td", { staticStyle: { width: "20px" } }),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "state2" },
                    [
                      _vm.movement < 1
                        ? [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/cargoStatus/OP1.png"),
                                alt: "",
                              },
                            }),
                          ]
                        : [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/cargoStatus/OP2.png"),
                                alt: "",
                              },
                            }),
                          ],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "state3" },
                    [
                      _vm.movement === "1"
                        ? [
                            _c(
                              "svg",
                              {
                                staticClass: "lds-message",
                                attrs: {
                                  width: "80px",
                                  height: "80px",
                                  xmlns: "http://www.w3.org/2000/svg",
                                  viewBox: "0 0 100 100",
                                  preserveAspectRatio: "xMidYMid",
                                },
                              },
                              [
                                _c(
                                  "g",
                                  { attrs: { transform: "translate(20 50)" } },
                                  [
                                    _c(
                                      "circle",
                                      {
                                        attrs: {
                                          cx: "0",
                                          cy: "0",
                                          r: "7",
                                          fill: "#e15b64",
                                          transform: "scale(0.99275 0.99275)",
                                        },
                                      },
                                      [
                                        _c("animateTransform", {
                                          attrs: {
                                            attributeName: "transform",
                                            type: "scale",
                                            begin: "-0.375s",
                                            calcMode: "spline",
                                            keySplines:
                                              "0.3 0 0.7 1;0.3 0 0.7 1",
                                            values: "0;1;0",
                                            keyTimes: "0;0.5;1",
                                            dur: "1s",
                                            repeatCount: "indefinite",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "g",
                                  { attrs: { transform: "translate(40 50)" } },
                                  [
                                    _c(
                                      "circle",
                                      {
                                        attrs: {
                                          cx: "0",
                                          cy: "0",
                                          r: "7",
                                          fill: "#f47e60",
                                          transform: "scale(0.773605 0.773605)",
                                        },
                                      },
                                      [
                                        _c("animateTransform", {
                                          attrs: {
                                            attributeName: "transform",
                                            type: "scale",
                                            begin: "-0.25s",
                                            calcMode: "spline",
                                            keySplines:
                                              "0.3 0 0.7 1;0.3 0 0.7 1",
                                            values: "0;1;0",
                                            keyTimes: "0;0.5;1",
                                            dur: "1s",
                                            repeatCount: "indefinite",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "g",
                                  { attrs: { transform: "translate(60 50)" } },
                                  [
                                    _c(
                                      "circle",
                                      {
                                        attrs: {
                                          cx: "0",
                                          cy: "0",
                                          r: "7",
                                          fill: "#f8b26a",
                                          transform: "scale(0.42525 0.42525)",
                                        },
                                      },
                                      [
                                        _c("animateTransform", {
                                          attrs: {
                                            attributeName: "transform",
                                            type: "scale",
                                            begin: "-0.125s",
                                            calcMode: "spline",
                                            keySplines:
                                              "0.3 0 0.7 1;0.3 0 0.7 1",
                                            values: "0;1;0",
                                            keyTimes: "0;0.5;1",
                                            dur: "1s",
                                            repeatCount: "indefinite",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "g",
                                  { attrs: { transform: "translate(80 50)" } },
                                  [
                                    _c(
                                      "circle",
                                      {
                                        attrs: {
                                          cx: "0",
                                          cy: "0",
                                          r: "7",
                                          fill: "#abbd81",
                                          transform: "scale(0.113418 0.113418)",
                                        },
                                      },
                                      [
                                        _c("animateTransform", {
                                          attrs: {
                                            attributeName: "transform",
                                            type: "scale",
                                            begin: "0s",
                                            calcMode: "spline",
                                            keySplines:
                                              "0.3 0 0.7 1;0.3 0 0.7 1",
                                            values: "0;1;0",
                                            keyTimes: "0;0.5;1",
                                            dur: "1s",
                                            repeatCount: "indefinite",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        : _vm.movement < 1
                        ? [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/cargoStatus/center1.png"),
                                alt: "",
                              },
                            }),
                          ]
                        : [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/cargoStatus/center2.png"),
                                alt: "",
                              },
                            }),
                          ],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "state2" },
                    [
                      _vm.movement < 2
                        ? [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/cargoStatus/OC1.png"),
                                alt: "",
                              },
                            }),
                          ]
                        : [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/cargoStatus/OC2.png"),
                                alt: "",
                              },
                            }),
                          ],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "state3" },
                    [
                      _vm.movement === "2"
                        ? [
                            _c(
                              "svg",
                              {
                                staticClass: "lds-message",
                                attrs: {
                                  width: "80px",
                                  height: "80px",
                                  xmlns: "http://www.w3.org/2000/svg",
                                  viewBox: "0 0 100 100",
                                  preserveAspectRatio: "xMidYMid",
                                },
                              },
                              [
                                _c(
                                  "g",
                                  { attrs: { transform: "translate(20 50)" } },
                                  [
                                    _c(
                                      "circle",
                                      {
                                        attrs: {
                                          cx: "0",
                                          cy: "0",
                                          r: "7",
                                          fill: "#e15b64",
                                          transform: "scale(0.99275 0.99275)",
                                        },
                                      },
                                      [
                                        _c("animateTransform", {
                                          attrs: {
                                            attributeName: "transform",
                                            type: "scale",
                                            begin: "-0.375s",
                                            calcMode: "spline",
                                            keySplines:
                                              "0.3 0 0.7 1;0.3 0 0.7 1",
                                            values: "0;1;0",
                                            keyTimes: "0;0.5;1",
                                            dur: "1s",
                                            repeatCount: "indefinite",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "g",
                                  { attrs: { transform: "translate(40 50)" } },
                                  [
                                    _c(
                                      "circle",
                                      {
                                        attrs: {
                                          cx: "0",
                                          cy: "0",
                                          r: "7",
                                          fill: "#f47e60",
                                          transform: "scale(0.773605 0.773605)",
                                        },
                                      },
                                      [
                                        _c("animateTransform", {
                                          attrs: {
                                            attributeName: "transform",
                                            type: "scale",
                                            begin: "-0.25s",
                                            calcMode: "spline",
                                            keySplines:
                                              "0.3 0 0.7 1;0.3 0 0.7 1",
                                            values: "0;1;0",
                                            keyTimes: "0;0.5;1",
                                            dur: "1s",
                                            repeatCount: "indefinite",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "g",
                                  { attrs: { transform: "translate(60 50)" } },
                                  [
                                    _c(
                                      "circle",
                                      {
                                        attrs: {
                                          cx: "0",
                                          cy: "0",
                                          r: "7",
                                          fill: "#f8b26a",
                                          transform: "scale(0.42525 0.42525)",
                                        },
                                      },
                                      [
                                        _c("animateTransform", {
                                          attrs: {
                                            attributeName: "transform",
                                            type: "scale",
                                            begin: "-0.125s",
                                            calcMode: "spline",
                                            keySplines:
                                              "0.3 0 0.7 1;0.3 0 0.7 1",
                                            values: "0;1;0",
                                            keyTimes: "0;0.5;1",
                                            dur: "1s",
                                            repeatCount: "indefinite",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "g",
                                  { attrs: { transform: "translate(80 50)" } },
                                  [
                                    _c(
                                      "circle",
                                      {
                                        attrs: {
                                          cx: "0",
                                          cy: "0",
                                          r: "7",
                                          fill: "#abbd81",
                                          transform: "scale(0.113418 0.113418)",
                                        },
                                      },
                                      [
                                        _c("animateTransform", {
                                          attrs: {
                                            attributeName: "transform",
                                            type: "scale",
                                            begin: "0s",
                                            calcMode: "spline",
                                            keySplines:
                                              "0.3 0 0.7 1;0.3 0 0.7 1",
                                            values: "0;1;0",
                                            keyTimes: "0;0.5;1",
                                            dur: "1s",
                                            repeatCount: "indefinite",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        : _vm.movement < 2
                        ? [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/cargoStatus/center1.png"),
                                alt: "",
                              },
                            }),
                          ]
                        : [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/cargoStatus/center2.png"),
                                alt: "",
                              },
                            }),
                          ],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "state2" },
                    [
                      _vm.movement < 3
                        ? [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/cargoStatus/ATD1.png"),
                                alt: "",
                              },
                            }),
                          ]
                        : [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/cargoStatus/ATD2.png"),
                                alt: "",
                              },
                            }),
                          ],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "state3" },
                    [
                      _vm.movement === "3"
                        ? [
                            _c(
                              "svg",
                              {
                                staticClass: "lds-message",
                                attrs: {
                                  width: "80px",
                                  height: "80px",
                                  xmlns: "http://www.w3.org/2000/svg",
                                  viewBox: "0 0 100 100",
                                  preserveAspectRatio: "xMidYMid",
                                },
                              },
                              [
                                _c(
                                  "g",
                                  { attrs: { transform: "translate(20 50)" } },
                                  [
                                    _c(
                                      "circle",
                                      {
                                        attrs: {
                                          cx: "0",
                                          cy: "0",
                                          r: "7",
                                          fill: "#e15b64",
                                          transform: "scale(0.99275 0.99275)",
                                        },
                                      },
                                      [
                                        _c("animateTransform", {
                                          attrs: {
                                            attributeName: "transform",
                                            type: "scale",
                                            begin: "-0.375s",
                                            calcMode: "spline",
                                            keySplines:
                                              "0.3 0 0.7 1;0.3 0 0.7 1",
                                            values: "0;1;0",
                                            keyTimes: "0;0.5;1",
                                            dur: "1s",
                                            repeatCount: "indefinite",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "g",
                                  { attrs: { transform: "translate(40 50)" } },
                                  [
                                    _c(
                                      "circle",
                                      {
                                        attrs: {
                                          cx: "0",
                                          cy: "0",
                                          r: "7",
                                          fill: "#f47e60",
                                          transform: "scale(0.773605 0.773605)",
                                        },
                                      },
                                      [
                                        _c("animateTransform", {
                                          attrs: {
                                            attributeName: "transform",
                                            type: "scale",
                                            begin: "-0.25s",
                                            calcMode: "spline",
                                            keySplines:
                                              "0.3 0 0.7 1;0.3 0 0.7 1",
                                            values: "0;1;0",
                                            keyTimes: "0;0.5;1",
                                            dur: "1s",
                                            repeatCount: "indefinite",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "g",
                                  { attrs: { transform: "translate(60 50)" } },
                                  [
                                    _c(
                                      "circle",
                                      {
                                        attrs: {
                                          cx: "0",
                                          cy: "0",
                                          r: "7",
                                          fill: "#f8b26a",
                                          transform: "scale(0.42525 0.42525)",
                                        },
                                      },
                                      [
                                        _c("animateTransform", {
                                          attrs: {
                                            attributeName: "transform",
                                            type: "scale",
                                            begin: "-0.125s",
                                            calcMode: "spline",
                                            keySplines:
                                              "0.3 0 0.7 1;0.3 0 0.7 1",
                                            values: "0;1;0",
                                            keyTimes: "0;0.5;1",
                                            dur: "1s",
                                            repeatCount: "indefinite",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "g",
                                  { attrs: { transform: "translate(80 50)" } },
                                  [
                                    _c(
                                      "circle",
                                      {
                                        attrs: {
                                          cx: "0",
                                          cy: "0",
                                          r: "7",
                                          fill: "#abbd81",
                                          transform: "scale(0.113418 0.113418)",
                                        },
                                      },
                                      [
                                        _c("animateTransform", {
                                          attrs: {
                                            attributeName: "transform",
                                            type: "scale",
                                            begin: "0s",
                                            calcMode: "spline",
                                            keySplines:
                                              "0.3 0 0.7 1;0.3 0 0.7 1",
                                            values: "0;1;0",
                                            keyTimes: "0;0.5;1",
                                            dur: "1s",
                                            repeatCount: "indefinite",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        : _vm.movement < 3
                        ? [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/cargoStatus/center1.png"),
                                alt: "",
                              },
                            }),
                          ]
                        : [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/cargoStatus/center2.png"),
                                alt: "",
                              },
                            }),
                          ],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "state2" },
                    [
                      _vm.movement < 4
                        ? [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/cargoStatus/ATA1.png"),
                                alt: "",
                              },
                            }),
                          ]
                        : [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/cargoStatus/ATA2.png"),
                                alt: "",
                              },
                            }),
                          ],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "state3" },
                    [
                      _vm.movement === "4"
                        ? [
                            _c(
                              "svg",
                              {
                                staticClass: "lds-message",
                                attrs: {
                                  width: "80px",
                                  height: "80px",
                                  xmlns: "http://www.w3.org/2000/svg",
                                  viewBox: "0 0 100 100",
                                  preserveAspectRatio: "xMidYMid",
                                },
                              },
                              [
                                _c(
                                  "g",
                                  { attrs: { transform: "translate(20 50)" } },
                                  [
                                    _c(
                                      "circle",
                                      {
                                        attrs: {
                                          cx: "0",
                                          cy: "0",
                                          r: "7",
                                          fill: "#e15b64",
                                          transform: "scale(0.99275 0.99275)",
                                        },
                                      },
                                      [
                                        _c("animateTransform", {
                                          attrs: {
                                            attributeName: "transform",
                                            type: "scale",
                                            begin: "-0.375s",
                                            calcMode: "spline",
                                            keySplines:
                                              "0.3 0 0.7 1;0.3 0 0.7 1",
                                            values: "0;1;0",
                                            keyTimes: "0;0.5;1",
                                            dur: "1s",
                                            repeatCount: "indefinite",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "g",
                                  { attrs: { transform: "translate(40 50)" } },
                                  [
                                    _c(
                                      "circle",
                                      {
                                        attrs: {
                                          cx: "0",
                                          cy: "0",
                                          r: "7",
                                          fill: "#f47e60",
                                          transform: "scale(0.773605 0.773605)",
                                        },
                                      },
                                      [
                                        _c("animateTransform", {
                                          attrs: {
                                            attributeName: "transform",
                                            type: "scale",
                                            begin: "-0.25s",
                                            calcMode: "spline",
                                            keySplines:
                                              "0.3 0 0.7 1;0.3 0 0.7 1",
                                            values: "0;1;0",
                                            keyTimes: "0;0.5;1",
                                            dur: "1s",
                                            repeatCount: "indefinite",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "g",
                                  { attrs: { transform: "translate(60 50)" } },
                                  [
                                    _c(
                                      "circle",
                                      {
                                        attrs: {
                                          cx: "0",
                                          cy: "0",
                                          r: "7",
                                          fill: "#f8b26a",
                                          transform: "scale(0.42525 0.42525)",
                                        },
                                      },
                                      [
                                        _c("animateTransform", {
                                          attrs: {
                                            attributeName: "transform",
                                            type: "scale",
                                            begin: "-0.125s",
                                            calcMode: "spline",
                                            keySplines:
                                              "0.3 0 0.7 1;0.3 0 0.7 1",
                                            values: "0;1;0",
                                            keyTimes: "0;0.5;1",
                                            dur: "1s",
                                            repeatCount: "indefinite",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "g",
                                  { attrs: { transform: "translate(80 50)" } },
                                  [
                                    _c(
                                      "circle",
                                      {
                                        attrs: {
                                          cx: "0",
                                          cy: "0",
                                          r: "7",
                                          fill: "#abbd81",
                                          transform: "scale(0.113418 0.113418)",
                                        },
                                      },
                                      [
                                        _c("animateTransform", {
                                          attrs: {
                                            attributeName: "transform",
                                            type: "scale",
                                            begin: "0s",
                                            calcMode: "spline",
                                            keySplines:
                                              "0.3 0 0.7 1;0.3 0 0.7 1",
                                            values: "0;1;0",
                                            keyTimes: "0;0.5;1",
                                            dur: "1s",
                                            repeatCount: "indefinite",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        : _vm.movement < 4
                        ? [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/cargoStatus/center1.png"),
                                alt: "",
                              },
                            }),
                          ]
                        : [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/cargoStatus/center2.png"),
                                alt: "",
                              },
                            }),
                          ],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "state2" },
                    [
                      _vm.movement < 5
                        ? [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/cargoStatus/IC1.png"),
                                alt: "",
                              },
                            }),
                          ]
                        : [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/cargoStatus/IC2.png"),
                                alt: "",
                              },
                            }),
                          ],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "state3" },
                    [
                      _vm.movement === "5"
                        ? [
                            _c(
                              "svg",
                              {
                                staticClass: "lds-message",
                                attrs: {
                                  width: "80px",
                                  height: "80px",
                                  xmlns: "http://www.w3.org/2000/svg",
                                  viewBox: "0 0 100 100",
                                  preserveAspectRatio: "xMidYMid",
                                },
                              },
                              [
                                _c(
                                  "g",
                                  { attrs: { transform: "translate(20 50)" } },
                                  [
                                    _c(
                                      "circle",
                                      {
                                        attrs: {
                                          cx: "0",
                                          cy: "0",
                                          r: "7",
                                          fill: "#e15b64",
                                          transform: "scale(0.99275 0.99275)",
                                        },
                                      },
                                      [
                                        _c("animateTransform", {
                                          attrs: {
                                            attributeName: "transform",
                                            type: "scale",
                                            begin: "-0.375s",
                                            calcMode: "spline",
                                            keySplines:
                                              "0.3 0 0.7 1;0.3 0 0.7 1",
                                            values: "0;1;0",
                                            keyTimes: "0;0.5;1",
                                            dur: "1s",
                                            repeatCount: "indefinite",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "g",
                                  { attrs: { transform: "translate(40 50)" } },
                                  [
                                    _c(
                                      "circle",
                                      {
                                        attrs: {
                                          cx: "0",
                                          cy: "0",
                                          r: "7",
                                          fill: "#f47e60",
                                          transform: "scale(0.773605 0.773605)",
                                        },
                                      },
                                      [
                                        _c("animateTransform", {
                                          attrs: {
                                            attributeName: "transform",
                                            type: "scale",
                                            begin: "-0.25s",
                                            calcMode: "spline",
                                            keySplines:
                                              "0.3 0 0.7 1;0.3 0 0.7 1",
                                            values: "0;1;0",
                                            keyTimes: "0;0.5;1",
                                            dur: "1s",
                                            repeatCount: "indefinite",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "g",
                                  { attrs: { transform: "translate(60 50)" } },
                                  [
                                    _c(
                                      "circle",
                                      {
                                        attrs: {
                                          cx: "0",
                                          cy: "0",
                                          r: "7",
                                          fill: "#f8b26a",
                                          transform: "scale(0.42525 0.42525)",
                                        },
                                      },
                                      [
                                        _c("animateTransform", {
                                          attrs: {
                                            attributeName: "transform",
                                            type: "scale",
                                            begin: "-0.125s",
                                            calcMode: "spline",
                                            keySplines:
                                              "0.3 0 0.7 1;0.3 0 0.7 1",
                                            values: "0;1;0",
                                            keyTimes: "0;0.5;1",
                                            dur: "1s",
                                            repeatCount: "indefinite",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "g",
                                  { attrs: { transform: "translate(80 50)" } },
                                  [
                                    _c(
                                      "circle",
                                      {
                                        attrs: {
                                          cx: "0",
                                          cy: "0",
                                          r: "7",
                                          fill: "#abbd81",
                                          transform: "scale(0.113418 0.113418)",
                                        },
                                      },
                                      [
                                        _c("animateTransform", {
                                          attrs: {
                                            attributeName: "transform",
                                            type: "scale",
                                            begin: "0s",
                                            calcMode: "spline",
                                            keySplines:
                                              "0.3 0 0.7 1;0.3 0 0.7 1",
                                            values: "0;1;0",
                                            keyTimes: "0;0.5;1",
                                            dur: "1s",
                                            repeatCount: "indefinite",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        : _vm.movement < 5
                        ? [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/cargoStatus/center1.png"),
                                alt: "",
                              },
                            }),
                          ]
                        : [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/cargoStatus/center2.png"),
                                alt: "",
                              },
                            }),
                          ],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "state2" },
                    [
                      _vm.movement < 6
                        ? [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/cargoStatus/DO1.png"),
                                alt: "",
                              },
                            }),
                          ]
                        : [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/cargoStatus/DO2.png"),
                                alt: "",
                              },
                            }),
                          ],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "state3" },
                    [
                      _vm.movement === "6"
                        ? [
                            _c(
                              "svg",
                              {
                                staticClass: "lds-message",
                                attrs: {
                                  width: "80px",
                                  height: "80px",
                                  xmlns: "http://www.w3.org/2000/svg",
                                  viewBox: "0 0 100 100",
                                  preserveAspectRatio: "xMidYMid",
                                },
                              },
                              [
                                _c(
                                  "g",
                                  { attrs: { transform: "translate(20 50)" } },
                                  [
                                    _c(
                                      "circle",
                                      {
                                        attrs: {
                                          cx: "0",
                                          cy: "0",
                                          r: "7",
                                          fill: "#e15b64",
                                          transform: "scale(0.99275 0.99275)",
                                        },
                                      },
                                      [
                                        _c("animateTransform", {
                                          attrs: {
                                            attributeName: "transform",
                                            type: "scale",
                                            begin: "-0.375s",
                                            calcMode: "spline",
                                            keySplines:
                                              "0.3 0 0.7 1;0.3 0 0.7 1",
                                            values: "0;1;0",
                                            keyTimes: "0;0.5;1",
                                            dur: "1s",
                                            repeatCount: "indefinite",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "g",
                                  { attrs: { transform: "translate(40 50)" } },
                                  [
                                    _c(
                                      "circle",
                                      {
                                        attrs: {
                                          cx: "0",
                                          cy: "0",
                                          r: "7",
                                          fill: "#f47e60",
                                          transform: "scale(0.773605 0.773605)",
                                        },
                                      },
                                      [
                                        _c("animateTransform", {
                                          attrs: {
                                            attributeName: "transform",
                                            type: "scale",
                                            begin: "-0.25s",
                                            calcMode: "spline",
                                            keySplines:
                                              "0.3 0 0.7 1;0.3 0 0.7 1",
                                            values: "0;1;0",
                                            keyTimes: "0;0.5;1",
                                            dur: "1s",
                                            repeatCount: "indefinite",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "g",
                                  { attrs: { transform: "translate(60 50)" } },
                                  [
                                    _c(
                                      "circle",
                                      {
                                        attrs: {
                                          cx: "0",
                                          cy: "0",
                                          r: "7",
                                          fill: "#f8b26a",
                                          transform: "scale(0.42525 0.42525)",
                                        },
                                      },
                                      [
                                        _c("animateTransform", {
                                          attrs: {
                                            attributeName: "transform",
                                            type: "scale",
                                            begin: "-0.125s",
                                            calcMode: "spline",
                                            keySplines:
                                              "0.3 0 0.7 1;0.3 0 0.7 1",
                                            values: "0;1;0",
                                            keyTimes: "0;0.5;1",
                                            dur: "1s",
                                            repeatCount: "indefinite",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "g",
                                  { attrs: { transform: "translate(80 50)" } },
                                  [
                                    _c(
                                      "circle",
                                      {
                                        attrs: {
                                          cx: "0",
                                          cy: "0",
                                          r: "7",
                                          fill: "#abbd81",
                                          transform: "scale(0.113418 0.113418)",
                                        },
                                      },
                                      [
                                        _c("animateTransform", {
                                          attrs: {
                                            attributeName: "transform",
                                            type: "scale",
                                            begin: "0s",
                                            calcMode: "spline",
                                            keySplines:
                                              "0.3 0 0.7 1;0.3 0 0.7 1",
                                            values: "0;1;0",
                                            keyTimes: "0;0.5;1",
                                            dur: "1s",
                                            repeatCount: "indefinite",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        : _vm.movement < 6
                        ? [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/cargoStatus/center1.png"),
                                alt: "",
                              },
                            }),
                          ]
                        : [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/cargoStatus/center2.png"),
                                alt: "",
                              },
                            }),
                          ],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "state2" },
                    [
                      _vm.movement < 7
                        ? [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/cargoStatus/ID1.png"),
                                alt: "",
                              },
                            }),
                          ]
                        : [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/cargoStatus/ID2.png"),
                                alt: "",
                              },
                            }),
                          ],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "state3" },
                    [
                      _vm.movement === "7"
                        ? [
                            _c(
                              "svg",
                              {
                                staticClass: "lds-message",
                                attrs: {
                                  width: "80px",
                                  height: "80px",
                                  xmlns: "http://www.w3.org/2000/svg",
                                  viewBox: "0 0 100 100",
                                  preserveAspectRatio: "xMidYMid",
                                },
                              },
                              [
                                _c(
                                  "g",
                                  { attrs: { transform: "translate(20 50)" } },
                                  [
                                    _c(
                                      "circle",
                                      {
                                        attrs: {
                                          cx: "0",
                                          cy: "0",
                                          r: "7",
                                          fill: "#e15b64",
                                          transform: "scale(0.99275 0.99275)",
                                        },
                                      },
                                      [
                                        _c("animateTransform", {
                                          attrs: {
                                            attributeName: "transform",
                                            type: "scale",
                                            begin: "-0.375s",
                                            calcMode: "spline",
                                            keySplines:
                                              "0.3 0 0.7 1;0.3 0 0.7 1",
                                            values: "0;1;0",
                                            keyTimes: "0;0.5;1",
                                            dur: "1s",
                                            repeatCount: "indefinite",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "g",
                                  { attrs: { transform: "translate(40 50)" } },
                                  [
                                    _c(
                                      "circle",
                                      {
                                        attrs: {
                                          cx: "0",
                                          cy: "0",
                                          r: "7",
                                          fill: "#f47e60",
                                          transform: "scale(0.773605 0.773605)",
                                        },
                                      },
                                      [
                                        _c("animateTransform", {
                                          attrs: {
                                            attributeName: "transform",
                                            type: "scale",
                                            begin: "-0.25s",
                                            calcMode: "spline",
                                            keySplines:
                                              "0.3 0 0.7 1;0.3 0 0.7 1",
                                            values: "0;1;0",
                                            keyTimes: "0;0.5;1",
                                            dur: "1s",
                                            repeatCount: "indefinite",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "g",
                                  { attrs: { transform: "translate(60 50)" } },
                                  [
                                    _c(
                                      "circle",
                                      {
                                        attrs: {
                                          cx: "0",
                                          cy: "0",
                                          r: "7",
                                          fill: "#f8b26a",
                                          transform: "scale(0.42525 0.42525)",
                                        },
                                      },
                                      [
                                        _c("animateTransform", {
                                          attrs: {
                                            attributeName: "transform",
                                            type: "scale",
                                            begin: "-0.125s",
                                            calcMode: "spline",
                                            keySplines:
                                              "0.3 0 0.7 1;0.3 0 0.7 1",
                                            values: "0;1;0",
                                            keyTimes: "0;0.5;1",
                                            dur: "1s",
                                            repeatCount: "indefinite",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "g",
                                  { attrs: { transform: "translate(80 50)" } },
                                  [
                                    _c(
                                      "circle",
                                      {
                                        attrs: {
                                          cx: "0",
                                          cy: "0",
                                          r: "7",
                                          fill: "#abbd81",
                                          transform: "scale(0.113418 0.113418)",
                                        },
                                      },
                                      [
                                        _c("animateTransform", {
                                          attrs: {
                                            attributeName: "transform",
                                            type: "scale",
                                            begin: "0s",
                                            calcMode: "spline",
                                            keySplines:
                                              "0.3 0 0.7 1;0.3 0 0.7 1",
                                            values: "0;1;0",
                                            keyTimes: "0;0.5;1",
                                            dur: "1s",
                                            repeatCount: "indefinite",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        : _vm.movement < 7
                        ? [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/cargoStatus/center1.png"),
                                alt: "",
                              },
                            }),
                          ]
                        : [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/cargoStatus/center2.png"),
                                alt: "",
                              },
                            }),
                          ],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "state2" },
                    [
                      _vm.movement < 8
                        ? [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/cargoStatus/MT1.png"),
                                alt: "",
                              },
                            }),
                          ]
                        : [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/cargoStatus/MT2.png"),
                                alt: "",
                              },
                            }),
                          ],
                    ],
                    2
                  ),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("tr", [
                    _c("td", {
                      staticClass: "state1",
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("cargoTracking.pickUp")),
                      },
                    }),
                    _vm._v(" "),
                    _vm.movement === "1"
                      ? _c(
                          "td",
                          {
                            staticClass: "state1",
                            staticStyle: { width: "40px" },
                          },
                          [_vm._v(" ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("td", {
                      staticClass: "state1",
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("cargoTracking.outboundCY")),
                      },
                    }),
                    _vm._v(" "),
                    _vm.movement === "2"
                      ? _c(
                          "td",
                          {
                            staticClass: "state1",
                            staticStyle: { width: "40px" },
                          },
                          [_vm._v(" ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("td", {
                      staticClass: "state1",
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("cargoTracking.departPOL")),
                      },
                    }),
                    _vm._v(" "),
                    _vm.movement === "3"
                      ? _c(
                          "td",
                          {
                            staticClass: "state1",
                            staticStyle: { width: "40px" },
                          },
                          [_vm._v(" ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("td", {
                      staticClass: "state1",
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("cargoTracking.berthPOD")),
                      },
                    }),
                    _vm._v(" "),
                    _vm.movement === "4"
                      ? _c(
                          "td",
                          {
                            staticClass: "state1",
                            staticStyle: { width: "40px" },
                          },
                          [_vm._v(" ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("td", {
                      staticClass: "state1",
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("cargoTracking.inboundCY")),
                      },
                    }),
                    _vm._v(" "),
                    _vm.movement === "5"
                      ? _c(
                          "td",
                          {
                            staticClass: "state1",
                            staticStyle: { width: "40px" },
                          },
                          [_vm._v(" ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("td", {
                      staticClass: "state1",
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("cargoTracking.release")),
                      },
                    }),
                    _vm._v(" "),
                    _vm.movement === "6"
                      ? _c(
                          "td",
                          {
                            staticClass: "state1",
                            staticStyle: { width: "40px" },
                          },
                          [_vm._v(" ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("td", {
                      staticClass: "state1",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("cargoTracking.inboundDelivery")
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _vm.movement === "7"
                      ? _c(
                          "td",
                          {
                            staticClass: "state1",
                            staticStyle: { width: "40px" },
                          },
                          [_vm._v(" ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("td", {
                      staticClass: "state1",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("cargoTracking.emptyContainer")
                        ),
                      },
                    }),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("h4", [_vm._v("Basic Information")]),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.baseInfo, border: "", stripe: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "blNo",
                      label: "B/L No",
                      "min-width": "30%",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "polEn",
                      label: "POL",
                      "min-width": "30%",
                      "show-overflow-tooltip": "true",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "delEn",
                      label: "Final Destination",
                      "min-width": "30%",
                      "show-overflow-tooltip": "true",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { display: "flex", "padding-top": "0px" } },
                [
                  _c("h4", [_vm._v("Sailing Schedule Information")]),
                  _c("h4", [
                    _vm._v("(" + _vm._s(_vm.$t("cargoTracking.tips_1"))),
                  ]),
                  _vm._v(" "),
                  _c("h4", { staticStyle: { color: "red" } }, [
                    _vm._v(
                      "\n      " + _vm._s(_vm.$t("cargoTracking.tips_2")) + ")"
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.sailingInfo, border: "", stripe: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "vesselName",
                      label: "VesselName",
                      "min-width": "12%",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.vesselName === "--" ||
                              scope.row.vesselName === "T/S"
                                ? _c("div", [
                                    _vm._v(_vm._s(scope.row.vesselName)),
                                  ])
                                : _c(
                                    "div",
                                    [
                                      _c(
                                        "el-link",
                                        {
                                          staticStyle: { "font-size": "12px" },
                                          attrs: { type: "primary" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleVesselName(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(scope.row.vesselName) +
                                              "\n            "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3433259213
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "voyage",
                      label: "Voyage",
                      "min-width": "7%",
                      "show-overflow-tooltip": "true",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                _vm._s(scope.row.voyageNo) +
                                  _vm._s(scope.row.voyageLeg)
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2130004724
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "portFromName",
                      label: "POL",
                      "min-width": "10%",
                      "show-overflow-tooltip": "true",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "etd",
                      label: "Schedule ETD",
                      "min-width": "10%",
                      formatter: _vm.formatDate,
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "atd",
                      label: "ETD/ATD",
                      "min-width": "12%",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.atd !== null
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v(_vm._s(scope.row.atd))]
                                  )
                                : _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.agtd === null
                                          ? scope.row.ctd === null
                                            ? scope.row.cctd === null
                                              ? "-"
                                              : scope.row.cctd
                                            : scope.row.ctd
                                          : scope.row.agtd
                                      )
                                    ),
                                  ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3349471493
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "portToName",
                      label: "POD",
                      "min-width": "10%",
                      "show-overflow-tooltip": "true",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "eta",
                      label: "Schedule ETA",
                      "min-width": "10%",
                      formatter: _vm.formatDate1,
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "ata",
                      label: "ETA/ATA",
                      sortable: "",
                      "min-width": "12%",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.ata !== null
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v(_vm._s(scope.row.ata))]
                                  )
                                : _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.agta === null
                                          ? scope.row.cta === null
                                            ? scope.row.ccta === null
                                              ? "-"
                                              : scope.row.ccta
                                            : scope.row.cta
                                          : scope.row.agta
                                      )
                                    ),
                                  ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      778278757
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "atb",
                      label: "ETB/ATB",
                      sortable: "",
                      "min-width": "12%",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.atb !== null
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v(_vm._s(scope.row.atb))]
                                  )
                                : _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.agtb === null
                                          ? scope.row.ctb === null
                                            ? scope.row.cctb === null
                                              ? "-"
                                              : scope.row.cctb
                                            : scope.row.ctb
                                          : scope.row.agtb
                                      )
                                    ),
                                  ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3391843013
                    ),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("h4", [_vm._v("Containers Information")]),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.containerInfo, border: "", stripe: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "index", "min-width": "3%" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "containerNo",
                      label: "Container No",
                      "min-width": "15%",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-link",
                                {
                                  staticStyle: { "font-size": "12px" },
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handle(scope.row)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(scope.row.containerNo) +
                                      "\n          "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      4152980667
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "sealNo1",
                      label: "Seal No",
                      "min-width": "12%",
                      "show-overflow-tooltip": "true",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "voyageNo",
                      label: "Voyage No",
                      "min-width": "12%",
                      "show-overflow-tooltip": "true",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "containerType",
                      label: "Container Type",
                      "min-width": "13%",
                      "show-overflow-tooltip": "true",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "quantity",
                      label: "Quantity",
                      "min-width": "10%",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.toScale(scope.row.quantity)) +
                                  "\n        "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2021296132
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "cntrSize",
                      label: "Measurement",
                      "min-width": "12%",
                      "show-overflow-tooltip": "true",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "weight",
                      label: "Gross Weight",
                      "min-width": "12%",
                      "show-overflow-tooltip": "true",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "movementNameEn",
                      label: "Current Status",
                      "min-width": "26%",
                      "show-overflow-tooltip": "true",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-link",
                                {
                                  staticStyle: { "font-size": "12px" },
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handle(scope.row)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.format(scope.row.currentPort)
                                      ) +
                                      " -\n            " +
                                      _vm._s(
                                        _vm.format(scope.row.movementNameEn)
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      971176649
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isResultSingle
        ? _c(
            "div",
            { staticClass: "result-container" },
            [
              _c("h4", [_vm._v("Sailing Schedule Information")]),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.singleInfo, border: "", stripe: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "index",
                      "min-width": "5%",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "Current Status",
                      prop: "movementCode",
                      "min-width": "25%",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "Local",
                      prop: "eventPort",
                      "min-width": "20%",
                      "show-overflow-tooltip": "true",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "Occurrence Time",
                      prop: "eventDate",
                      "min-width": "20%",
                      formatter: _vm.formatDate2,
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "Vessel Name",
                      prop: "vesselCode",
                      "min-width": "15%",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "Voyage No",
                      prop: "voyageNo",
                      "min-width": "15%",
                      align: "center",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { width: "60%", visible: _vm.dialogTableVisible },
          on: {
            "update:visible": function ($event) {
              _vm.dialogTableVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.postInfo, border: "", stripe: "" },
            },
            [
              _c("el-table-column", {
                attrs: { type: "index", "min-width": "5%" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "Current Status",
                  prop: "movementNameEn",
                  "min-width": "45%",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "Local",
                  prop: "portName",
                  "min-width": "25%",
                  "show-overflow-tooltip": "true",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "Occurrence Time",
                  prop: "eventDate",
                  "min-width": "25%",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }